import { BULK_UPDATE_PROJECT_STATUS, BULK_UPDATE_PROJECT_STATUS_ERROR, GET_CLIENT_PROJECT_BY_REFNUM, GET_CLIENT_PROJECT_BY_REFNUM_ERROR, GET_SUB_CLIENT_PROJECT_LIST, GET_SUB_CLIENT_PROJECT_LIST_ERROR, GET_SUB_PROJECT_LIST, GET_SUB_PROJECT_LIST_ERROR, GET_SUB_PROJECT_STATUS_LIST, GET_SUB_PROJECT_STATUS_LIST_ERROR, RESET_CLIENT_PROJECT_DETAILS, RESET_CLIENT_PROJECT_LIST } from "../../actions/types";

const initialState = {
    subClientProjectList: [],
    subClientProjectStatusList: [],
    bulkUpdateClientProject: false,
    subClientProjectDetails: {},
    subClientProjectListForTimesheet: [],
}

export const project = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUB_CLIENT_PROJECT_LIST:
            return {
                ...state,
                subClientProjectList: action.payload.data,
            };

        case GET_SUB_CLIENT_PROJECT_LIST_ERROR:
            return {
                ...state,
                subClientProjectList: [],
            };

        case GET_SUB_PROJECT_STATUS_LIST:
            return {
                ...state,
                subClientProjectStatusList: action.payload.data,
            };

        case GET_SUB_PROJECT_STATUS_LIST_ERROR:
            return {
                ...state,
                subClientProjectStatusList: [],
            };

        case RESET_CLIENT_PROJECT_LIST:
            return {
                ...state,
                subClientProjectStatusList: [],
                subClientProjectList: [],   
            }
        
        case BULK_UPDATE_PROJECT_STATUS: {
            return{
                ...state,
                bulkUpdateClientProject: true
            }
        }
        case BULK_UPDATE_PROJECT_STATUS_ERROR: {
            return{
                ...state,
                bulkUpdateClientProject: false
            }
        }
        case GET_CLIENT_PROJECT_BY_REFNUM: {
            return {
                ...state,
                subClientProjectDetails: action.payload.data,
            };
        }
        case GET_CLIENT_PROJECT_BY_REFNUM_ERROR: {
            return {
                ...state,
                subClientProjectDetails: {},
            };
        }

        case RESET_CLIENT_PROJECT_DETAILS: {
            return {
                ...state,
                subClientProjectDetails: {},
                subClientProjectList: [],
            }
        }

        case GET_SUB_PROJECT_LIST: {
            return {
                ...state,
                subClientProjectListForTimesheet: action.payload.data,
            }
        }
        case GET_SUB_PROJECT_LIST_ERROR: {
            return {
                ...state,
                subClientProjectListForTimesheet: [],
            }
        }

        default:
            return state;
    }
}

export default project;